export default __webpack_public_path__ + "static/media/distance.dbf65211.svg";